import React from 'react';

import Select from '../../../../../select/select';
import FitmentStepContainer from '../fitment-step-container/fitment-step-container';

import { useFeatureFlags } from '../../../../../../shared/hooks/hooks';

import type { OptionValue } from '../../../../../../shared/types/select';
import { FEATURE_FLAGS } from '../../../../../../shared/constants/feature-flags';

import './fitment-select.scss';

interface FitmentSelectProps {
  className?: string;
  heading?: React.ReactNode;
  hideHeading?: boolean;
  isDisabled?: boolean;
  moreInfoContent?: () => JSX.Element;
  name: string;
  onChange: () => void;
  onFocus: () => void;
  onMoreInfoContentClick?: () => void;
  options: OptionValue[];
  placeholder: string;
  renderNoResultsFound: (props) => React.ReactElement;
  renderOption?: (props) => React.ReactElement;
  renderValue?: (props) => React.ReactElement;
  selectedOption: OptionValue;
  shouldAutofocus?: boolean;
  shouldOpenMenuByDefault?: boolean;
  subject?: string;
}

function FitmentSelect(props: FitmentSelectProps) {
  const {
    className = '',
    heading,
    hideHeading = false,
    isDisabled = false,
    moreInfoContent,
    name,
    onChange,
    onFocus,
    onMoreInfoContentClick,
    options,
    placeholder,
    renderNoResultsFound,
    renderOption,
    renderValue,
    selectedOption,
    shouldAutofocus = false,
    shouldOpenMenuByDefault,
    subject
  } = props;

  const { featureFlags } = useFeatureFlags();
  const isFitmentRedesign = Boolean(
    featureFlags?.[FEATURE_FLAGS.__FF_FITMENT_REDESIGN__]
  );

  const defaultHeading = isFitmentRedesign ? (
    <>What is your vehicle {placeholder?.toLowerCase()}?</>
  ) : (
    <>
      What is the <strong>{placeholder?.toLowerCase()}</strong> of your{' '}
      {subject || 'vehicle'}?
    </>
  );
  const fitmentStepContainerHeading = heading || defaultHeading;

  return (
    <FitmentStepContainer
      className={`fitment-select ${className}`}
      heading={hideHeading ? undefined : fitmentStepContainerHeading}
      moreInfoContent={moreInfoContent}
      onMoreInfoContentClick={onMoreInfoContentClick}
    >
      <Select
        aria-labelledby="fitment-step-container-heading"
        data-testid={`fitment-select__${name}`}
        isDisabled={isDisabled}
        isMenuOpenByDefault={shouldOpenMenuByDefault}
        isRequired
        isSearchable
        label={placeholder}
        name={name}
        onChange={onChange}
        onFocus={onFocus}
        options={options}
        renderNoResultsFound={renderNoResultsFound}
        renderOption={renderOption}
        renderValue={renderValue}
        shouldAutofocus={shouldAutofocus}
        styleName="select"
        value={selectedOption ?? null}
      />
    </FitmentStepContainer>
  );
}

export default FitmentSelect;
